// extracted by mini-css-extract-plugin
module.exports = {"google":"GoogleButton_google__pIDBJ","image":"GoogleButton_image__1kE7p"};